import React, {
  ReactElement,
  Component,
  useEffect,
  useContext,
  useState,
  Dispatch,
  useRef,
  useMemo,
  SetStateAction,
  Fragment,
  useCallback
} from 'react';
import "../backup.less";
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {workspace_icon} from '../../../../img';
import {Col, Modal, Row, Spin, Switch, Tooltip, Typography} from "antd";
import TableList from "../../../../components/new-table-list/table-list";
import {operation_type, result_args_type, sorter_type} from '../../../../components/new-table-list/interface';
import {TableListContext, table_list_type, item_type} from '../../contexts/table-list';
import {top_navbar_type, TopNavbarContext} from '../../contexts/top-navbar';
import get_time from "../../../../shared-functions/get-time";
import get_name from "../../../../shared-functions/get-name";
import set_name from "../../../../shared-functions/set-name";
import {PlayCircleOutlined, EditOutlined, DeleteOutlined} from '@ant-design/icons';
import {post_processes_args_default, response_type} from '../../../../http-worker/function/interfaces';
import {backup_operation, modal_type} from "./backup.operation";
import {CronTextContext} from '../cron/cron-text';
import {DatacenternameContext} from '../../../../contexts/datacenter-name';
import {format_time, http_get, http_patch} from '../../common-file/service';
import {IUserInfoType, UserInfoContext} from '../../../../contexts/user-info';
import {LangContext} from '../../../../contexts/lang';
import {useDeepCompareEffect} from 'use-deep-compare';
import ArrowBack from "../../component/arrow-back";
import {ContentSidebarToggleContext} from "../../contexts/content-sidebar-toggle";
import {http_request_new, destroy_worker, http_request} from "../../../../http-worker/http-func";


export type format_message_type = (id: { id: string }, value?: { [key: string]: string }) => string;

/**
 * 驗證重名
 * @param {format_message_type} formatMessage 多語言
 * @param {{ name: string, id: string }[] | undefined} items 列表內容
 */
export const check_existed = (formatMessage: format_message_type, items: item_type[] | undefined, action: number | undefined, item_selected: item_type | undefined) => ({
  validator(_rule: any, value: string) {
    return value?.length > 0 && (
      items?.find(({name, id}) => {
        return action ? name === value && item_selected?.id !== id : name === value
      }))
      ? Promise.reject(formatMessage({id: 'this_name_has_been_existed'}))
      : Promise.resolve();
  }
});

export function backup_post_process({response, resolve}: post_processes_args_default) {
  (response as any)?.items?.forEach((response_each: response_type) => {
    (response_each as any).id = (response_each as any).db_backup_id;
    (response_each as any).name = (response_each as any).db_backup_id;
    (response_each as any).backup_id = (response_each as any).db_backup_id;
    (response_each as any).service_name = (response_each as any).service;
    (response_each as any).backup_duration = (response_each as any).duration;
    (response_each as any).expiry_time = (response_each as any).expired_at;
    (response_each as any).backup_destination_storage = (response_each as any).db_storage?.name;
    (response_each as any).storage_type = (response_each as any).db_storage?.storage_device_type;
    (response_each as any).storage_name = (response_each as any).db_storage?.name;
    (response_each as any).status = (response_each as any).status || "Pending";
    // (response_each as any).backup_type = (response_each as any).selected_database ? "Incremental" : "Full";
    (response_each as any).selected_database = (response_each as any).selected_database ? (response_each as any).selected_database : "";
    delete (response_each as any).service;
    delete (response_each as any).duration;
  });
  resolve(response);
}

export function backup_config_post_process({response, resolve}: post_processes_args_default) {
  (response as any)?.items?.forEach((response_each: response_type) => {
    (response_each as any).configuration_name = (response_each as any).db_backup_config?.name;
    (response_each as any).name = (response_each as any).db_backup_config?.name;
    (response_each as any).id = (response_each as any).db_backup_config?.id;
    (response_each as any).backup_type = (response_each as any).manifest?.backup_type;
    (response_each as any).selected_database = (response_each as any).manifest?.selected_database ? (response_each as any).manifest?.selected_database : "";
    (response_each as any).backup_destination_storage = (response_each as any).manifest?.db_storage?.name;
  });
  resolve(response);
}

export function backup_schedule_post_process({response, resolve}: post_processes_args_default) {
  (response as any)?.items?.forEach((response_each: response_type) => {
    (response_each as any).schedule_name = (response_each as any).db_schedule?.name;
    (response_each as any).name = (response_each as any).db_schedule?.name;
    (response_each as any).id = (response_each as any).db_schedule?.id;
    (response_each as any).configuration_name = (response_each as any).db_backup_config?.name;
    (response_each as any).cron_time = (response_each as any).schedule;
    (response_each as any).status = (response_each as any).status || "Disabled";
    // delete (response_each as any).time_description;
  });
  resolve(response);
}

export function restore_post_process({response, resolve}: post_processes_args_default) {
  (response as any)?.items?.forEach((response_each: response_type) => {
    // (response_each as any).backup_name = (response_each as any).db_backup?.name;
    // db_restore_id
    (response_each as any).name = (response_each as any).db_restore_id;
    (response_each as any).id = (response_each as any).db_restore_id;
    (response_each as any).backup_id = (response_each as any).db_backup_id;
    (response_each as any).restore_start_time = (response_each as any).start_time;
    (response_each as any).restore_end_time = (response_each as any).end_time;
    (response_each as any).service_name = (response_each as any).service;
    (response_each as any).restore_duration = (response_each as any).duration;
    (response_each as any).selected_database = (response_each as any).selected_database ? (response_each as any).selected_database : "";
    // (response_each as any).backup_type = (response_each as any).selected_database ? "Incremental" : "Full";
    delete (response_each as any).service;
    delete (response_each as any).start_time;
    delete (response_each as any).end_time;
  });
  resolve(response);
}

export const backup_status: any = {
  "succeeded": "#00A971",
  "enabled": "#00A971",
  "failed": "#FD3C35",
  "running": "#019ff3",
  "pending": "#faad14",
  "disabled": "#afafaf"
};

export const set_array = (key_array: string[], set_context: React.Dispatch<React.SetStateAction<any>>) => {
  const get_array_new: { [key: string]: (value: any) => void } = {};
  key_array.forEach((key: string) => {
    get_array_new[`set_${key}`] = (value: any) => {
      set_context((currentState: any): any => ({
        ...currentState,
        [key]: value
      }));
    };
  });
  return get_array_new;
};

export interface storage_detail {
  id: string,
  name: string
}

export interface storage_type {
  type: string,
  db_storage: storage_detail[]
}

const BackUp: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {

  const {formatMessage} = props.intl,
    [format_subscriptions, set_format_subscriptions]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]),
    [sso_subscriptions, set_sso_subscriptions]: [any, Dispatch<SetStateAction<any>>] = useState([]),
    instance_item_selected = useMemo(()=> JSON.parse(sessionStorage.getItem('instance_list_item_selected') || '{}'), []),
    [config_list_display, set_config_list_display]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
    [backup_list_display, set_backup_list_display]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
    [restore_list_display, set_restore_list_display]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
    [schedule_list_display, set_schedule_list_display]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),

    [instance_list, set_instance_list]: [any[] | undefined, Dispatch<SetStateAction<any[] | undefined>>] = useState<any[] | undefined>([]),
    [item_selected, set_item_selected]: [item_type | undefined, Dispatch<SetStateAction<item_type | undefined>>] = useState<item_type | undefined>(),
    service_name: string = instance_item_selected?.service,
    [service_plan, set_service_plan]: [any, Dispatch<SetStateAction<any>>] = useState(instance_item_selected?.plan),
    [selected_config, set_selected_config]: [item_type | undefined, Dispatch<SetStateAction<item_type | undefined>>] = useState<item_type | undefined>(),
    [visible, set_visible]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>(),
    [action_id, set_action_id]: [number | undefined, React.Dispatch<React.SetStateAction<number | undefined>>] = useState<number | undefined>(),
    [content_sidebar_selected, set_content_sidebar_selected]: [string, Dispatch<SetStateAction<string>>] = useState<string>(sessionStorage.getItem("sidebar_selected") || 'backup_configuration'),
    [selectable, set_selectable]: [number | undefined, Dispatch<SetStateAction<number | undefined>>] = useState<number | undefined>(0),
    content_sidebar_toggle: boolean = useContext(ContentSidebarToggleContext)[0],
    [selected_row_keys, set_selected_row_keys]: [any[] | undefined, Dispatch<SetStateAction<any[] | undefined>>] = useState<any[] | undefined>([]),
    [disabled_hours, set_disabled_hours]: [boolean, Dispatch<SetStateAction<boolean>>] = useState<boolean>(false),
    sidemenu_list: React.MutableRefObject<string[]> = useRef(["backup_configuration", "backup_management", "restore_management", "backup_schedule"]),
    [filter_operations, set_filter_operations]: [operation_type[] | undefined, Dispatch<SetStateAction<operation_type[] | undefined>>] = useState<operation_type[] | undefined>([]),
    [action, set_action]: [modal_type['action'] | undefined, React.Dispatch<React.SetStateAction<modal_type['action'] | undefined>>] = useState<modal_type['action'] | undefined>(),
    [month_selected_list, set_month_selected_list]: [string[], Dispatch<SetStateAction<string[]>>] = useState<string[]>([]),
    [month_item_status, set_month_item_status]: [boolean[], Dispatch<SetStateAction<boolean[]>>] = useState<boolean[]>([]),
    [storage_list, set_storage_list]: [storage_type[] | undefined, Dispatch<SetStateAction<storage_type[] | undefined>>] = useState<storage_type[] | undefined>(),
    [backup_config_list, set_backup_config_list]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
    [backup_list, set_backup_list]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
    [restore_list, set_restore_list]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
    [backup_schedule_list, set_backup_schedule_list]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
    [start_time, set_start_time]: [any | undefined, Dispatch<SetStateAction<any | undefined>>] = useState<any | undefined>(),
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    top_navbar: top_navbar_type = useContext(TopNavbarContext)[0],
    [table_list, set_table_list]: [table_list_type, React.Dispatch<React.SetStateAction<table_list_type>>] = useContext(TableListContext),
    [table_titles, set_table_titles]: [string[], Dispatch<SetStateAction<string[]>>] = useState<string[]>([]),
    [storage_datasource, set_storage_datasource]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
    [db_list, set_db_list]: [any, Dispatch<SetStateAction<any>>] = useState<any>(),
    [restore_db_list, set_restore_db_list]: [string[] | undefined, Dispatch<SetStateAction<string[] | undefined>>] = useState<string[] | undefined>(),
    [cron_text, set_cron_text]: [string, React.Dispatch<React.SetStateAction<string>>] = useContext(CronTextContext),
    [view_log, set_view_log]: [string, Dispatch<SetStateAction<string>>] = useState<string>(""),
    [config_schedule_list, set_config_schedule_list]: [any[] | undefined, Dispatch<SetStateAction<any[] | undefined>>] = useState<any[] | undefined>(),
    [enable_schedule_list, set_enable_schedule_list]: [any[] | undefined, Dispatch<SetStateAction<any[] | undefined>>] = useState<any[] | undefined>(),
    [loading, set_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    [default_sorter_col, set_default_sorter_col]: [sorter_type, React.Dispatch<React.SetStateAction<sorter_type>>] = useState<sorter_type>({} as sorter_type),
    [loading_done, set_loading_done]: [{ [key: string]: 0 | 1 }, React.Dispatch<React.SetStateAction<{ [key: string]: 0 | 1 }>>] = useState<{
      [key: string]: 0 | 1;
    }>({}),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    lang: string = useContext(LangContext)[0],
    [search_value, set_search_value]: [table_list_type['search_value'], React.Dispatch<React.SetStateAction<table_list_type['search_value']>>] = useState<table_list_type['search_value']>(''),
    monthOptions = useRef(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"]);

  const status_option_list: { name: string; status: string }[] = useMemo(() => {
    return content_sidebar_selected !== "backup_schedule" ?
      [
        {name: "Succeeded", status: "succeeded"},
        {name: "Pending", status: "pending"},
        {name: "Failed", status: "failed"},
        {name: "Running", status: "running"}
      ] :
      [
        {name: "Enabled", status: "Enabled"},
        {name: "Disabled", status: "Disabled"}
      ]
  }, [content_sidebar_selected]);

  const type_option_list: { name: string; status: string }[] = useMemo(() => {
    return content_sidebar_selected !== "backup_schedule" ?
      [
        {name: formatMessage({id: "Full"}), status: "Full"}
        // { name: "Incremental", status: "Incremental" }
      ] :
      [
        // { name: "minute", status: "minute" },
        {name: "hour", status: "hour"},
        {name: "day", status: "day"},
        {name: "month", status: "month"},
        {name: "week", status: "week"}
      ]
  }, [content_sidebar_selected, formatMessage]);

    // 離開頁面前銷毀所有 web worker
    useEffect(() => () => { destroy_worker() }, []);

    // 默认的表格排序方式
    useEffect((): void => {
        set_default_sorter_col({ column_key: `${content_sidebar_selected === "backup_management" ? "start_time" : "restore_start_time"}`, order: "descend" });
    }, [content_sidebar_selected]);

    useEffect(()=>{
      if(!instance_item_selected?.plan && instance_item_selected?.instanceId){
        (async ()=>{
          const {servicePlanName} = (await http_get(`/serviceHub/v2/serviceInstances/${instance_item_selected?.instanceId}`, props) as any)?.data;
          set_service_plan(servicePlanName)
        })()
      }
      // eslint-disable-next-line
    }, [instance_item_selected]);

  useEffect(() => {
    if (props && user_info?.ssoRole) {
      (async () => {
        if (user_info?.ssoRole === "globalAdmin") {
          const sso_subscription: any = await http_get(`/v4.0/subscriptions?maxResults=9999&page=&direction=&property=`, props) || {};
          set_sso_subscriptions(sso_subscription?.data?.resources || []);
        } else {
          const sso_subscription: any = await http_get(`/v4.0/users/me`,props);
          set_sso_subscriptions(sso_subscription?.data?.userSubscriptions || []);
        }
      })()
    }
    // eslint-disable-next-line
  }, [user_info?.ssoRole]);

  useEffect((): void => {
    let subscriptions: any[] = [];
    sso_subscriptions?.length && sso_subscriptions.map((item: any) => {
      return subscriptions.push({
        id: item.subscriptionId || item.id,
        name: item.subscriptionName || item.name,
        company: item.company,
        role: item.subscriptionRole || item.role
      })
    });
    set_format_subscriptions(subscriptions);
  }, [sso_subscriptions]);

  useDeepCompareEffect((): void => {
    set_name('backup_search', search_value || '', set_table_list);
  }, [search_value]);

  useEffect(() => {
      // 支持 restore 时更改 instance
      if (datacenter_name && (content_sidebar_selected === "backup_management") && props) {
          (async () => {
              const list: any = [],
                instance_datasource = (await http_get(`/serviceHub/v2/subscriptions/${instance_item_selected?.subscriptionId}/serviceInstances?serviceName=${instance_item_selected?.service}&datacenterCode=${datacenter_name}`, props) as any)?.data?.services || [];
              instance_datasource?.map((val: any, key: any) => {
                  const {
                      serviceInstanceId,
                      serviceInstanceName,
                      subscriptionId,
                      transactionId,
                      serviceCategory,
                      userId,
                      serviceName,
                      datacenterCode,
                      servicePlanName,
                      createdAt,
                      dashboardUrl,
                      bindable,
                      subscriptionCompany,
                      subscriptionName,
                      lifecycleStatus,
                      userProvided
                  } = val;
                  lifecycleStatus?.toLowerCase() !== 'none' && list.push({
                      key: key,
                      instance_id: serviceInstanceId,
                      instance_name: serviceInstanceName,
                      subscriptionId: subscriptionId,
                      transactionId: transactionId,
                      serviceCategory: serviceCategory,
                      userId: userId,
                      service_name: serviceName,
                      datacenterCode: datacenterCode,
                      plan: servicePlanName,
                      status: lifecycleStatus,
                      creation_time_mp: format_time(createdAt),
                      dashboard_url: dashboardUrl,
                      bindable: bindable,
                      company: subscriptionCompany,
                      subscription_name: subscriptionName,
                      user_provided: userProvided
                  });
                  return list
              });
              set_instance_list(list);
          })()
      }
    // eslint-disable-next-line
  }, [datacenter_name, content_sidebar_selected]);

    useEffect((): void => {
        // storage list
        http_request('dbStorages', props, set_storage_datasource, `/backup/dbStorages?subscriptionId=${instance_item_selected?.subscriptionId}`, 0);
        // eslint-disable-next-line
    }, []);

  // 获取 dbStorage 列表
  useEffect(() => {
    let storage_resource: storage_type[] = [];
    let storage_detail: storage_detail[];
    storage_datasource?.length && storage_datasource?.map(item => {
      storage_detail = [];
      const format_list: storage_type[] = storage_resource.filter(({type}) => {
        return type === item.storage_device?.type
      });
      if (!format_list.length) {
        storage_detail.push({id: item.db_storage?.id as string, name: item.db_storage?.name as string});
        storage_resource.push({type: item.storage_device?.type as string, db_storage: storage_detail});
      } else {
        format_list[0].db_storage.push({id: item.db_storage?.id as string, name: item.db_storage?.name as string});
      }
      return item
    })
    set_storage_list(storage_resource);
    // set_storage_list([{ type: "NFS", db_storage: [{ id: "0", name: "NFS" }] }, ...storage_resource])
  }, [storage_datasource])

  useEffect((): void => {
    set_name("backup_type", table_list?.backup_type ? formatMessage({id: "Full"}) : "", set_table_list);
  }, [formatMessage, table_list?.backup_type, set_table_list])

  useEffect((): void => {
    get_name('status', table_list, set_table_list, status_option_list);
    get_name(content_sidebar_selected === "backup_schedule" ? "frequency" : "backup_type", table_list, set_table_list, type_option_list);
    // eslint-disable-next-line
  }, [set_table_list, content_sidebar_selected]);

  const result_to_do = useCallback((args: result_args_type) => {
    const {action} = args.props;
    (action === 2 || (content_sidebar_selected === "backup_schedule" && action === 1)) && set_loading_done((current_state: { [key: string]: 0 | 1 }) => ({
      ...current_state,
      backup_configuration: 0,
      backup: 0,
      restore_management: 0,
      backup_schedule: 0
    }));
    if (content_sidebar_selected === "backup_configuration") {
      (async () => {
        // 當更新備份配置成功時，相關連的備份排程會同時被呼叫PATCH dbschedule api，確保k8s上同步更新
        if (action === 1 && item_selected) {
          const schedule_list: any[] = (await http_get(`/backup/dbSchedules?instanceId=${item_selected.manifest?.instance_id}&dbBackupConfigId=${item_selected.db_backup_config?.id}`, props) as any)?.data?.items || [];
          for (let item of schedule_list) {
            try {
              http_patch(
                `/backup/dbSchedules/${item?.dbSchedule?.id}`,
                {
                  dbScheduleName: item?.dbSchedule?.name,
                  frequency: item?.frequency,
                  dbBackupConfigId: item?.dbBackupConfig?.id,
                  schedule: item?.schedule
                },
                props,
                {"Content-Type": "application/merge-patch+json"}
              );
            } catch (error) {
            }
          }
        }
      })()
    }
  }, [content_sidebar_selected, props, item_selected]);

  useEffect(() => {
    // 立即备份弹窗内刷新页面需要获取 backup_config 列表
    switch (content_sidebar_selected) {
      case "backup_configuration":
      case "backup_management":
      case "backup_schedule":
        !loading_done.backup_configuration &&
        http_request_new({
          key: 'backup_configuration',
          props: props,
          func: set_backup_config_list,
          url: `/backup/dbBackupConfigs?instanceId=${instance_item_selected?.instanceId}`,
          method: 0,
          post_process: backup_config_post_process,
          set_loading_done
        }).finally(()=>{
          set_loading_done((current_state: { [key: string]: 0 | 1 }) => ({
            ...current_state,
            backup_configuration: 1,
            backup: 1,
            backup_schedule: 1,
          }));
        });
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [content_sidebar_selected, loading_done.backup_configuration]);

  useEffect((): void => {
    // (async () => {
    let filter_operations_data: operation_type[] = [];
    if (backup_operation().length) {
      switch (content_sidebar_selected) {
        case "backup_configuration":
          set_table_titles(['configuration_name', 'backup_type', 'selected_database', 'backup_destination_storage', 'backup', 'edit', 'delete']);
          filter_operations_data = backup_operation() ? [...backup_operation().slice(5, 9)] : [];
          set_filter_operations(filter_operations_data);
          // set_loading_done((current_state: any) => ({
          //   ...current_state,
          //   backup_configuration: 1
          // }));
          break;
        case "backup_management":
          !loading_done.backup &&
          http_request_new({
            key: 'backup',
            props: props,
            func: set_backup_list,
            url: `/backup/dbBackups?instanceId=${instance_item_selected?.instanceId}`,
            method: 0,
            post_process: backup_post_process,
            set_loading_done
          }).finally(()=>{
            set_loading_done((current_state: any) => ({
              ...current_state,
              backup: 1
            }));
          });
          // 执行 Restore 后更新 Restore 列表
          set_loading_done((current_state: { [key: string]: 0 | 1 }) => ({
            ...current_state,
            restore_management: 0,
          }));
          set_table_titles(['status', 'backup_id', 'start_time', 'end_time', 'selected_database', 'backup_destination_storage', 'operation']);
          filter_operations_data = backup_operation() ? [...backup_operation().slice(0, 5)] : [];
          if (item_selected) {
            switch (item_selected.status) {
              // case "Unknown":
              case "Failed":
                set_filter_operations(filter_operations_data.slice(0, 3).concat(filter_operations_data.slice(4)));
                break;
              case "Pending":
                set_filter_operations(filter_operations_data.slice(0, 3).concat(filter_operations_data.slice(4)));
                break;
              case "Succeeded":
                set_filter_operations(filter_operations_data.slice(0, 5));
                break;
              case "Running":
                set_filter_operations(filter_operations_data.slice(0, 3).concat(filter_operations_data.slice(4)));
                break;
              default:
                set_filter_operations(filter_operations_data.slice(0, 3).concat(filter_operations_data.slice(4)));
                break;
            }
          } else {
            set_filter_operations(filter_operations_data);
          }
          break;
        case "restore_management":
          !loading_done.restore_management &&
          http_request_new({
            key: 'restore_management',
            props: props,
            func: set_restore_list,
            url: `/backup/dbRestores?instanceId=${instance_item_selected?.instanceId}`,
            method: 0,
            post_process: restore_post_process,
            set_loading_done
          }).finally(()=>{
            set_loading_done((current_state: any) => ({
              ...current_state,
              restore_management: 1
            }));
          });
          set_table_titles(['status', 'db_restore_id', 'selected_database', 'new_database_name', 'restore_start_time', 'restore_end_time', 'operation']);
          filter_operations_data = backup_operation() ? [...backup_operation().slice(9, 12)] : [];
          if (item_selected) {
            switch (item_selected.status) {
              case "Failed":
                set_filter_operations(filter_operations_data.slice(0, 3));
                break;
              case "Pending":
                set_filter_operations(filter_operations_data.slice(0, 3));
                break;
              case "Succeeded":
                set_filter_operations(filter_operations_data.slice(0, 3));
                break;
              case "Running":
                set_filter_operations(filter_operations_data.slice(0, 3));
                break;
              default:
                set_filter_operations(filter_operations_data.slice(0, 3));
                break;
            }
          } else {
            set_filter_operations(filter_operations_data);
          }
          break;
        case "backup_schedule":
          !loading_done.backup_schedule &&
          http_request_new({
            key: 'backup_schedule',
            props: props,
            func: set_backup_schedule_list,
            url: `/backup/dbSchedules?instanceId=${instance_item_selected?.instanceId}`,
            method: 0,
            post_process: backup_schedule_post_process,
            set_loading_done
          }).finally(()=>{
            set_loading_done((current_state: any) => ({
              ...current_state,
              backup_schedule: 1
            }));
          });
          set_table_titles(['status', 'schedule_name', 'frequency', 'cron_time', 'configuration_name', 'enable', 'edit', 'delete']);
          filter_operations_data = backup_operation() ? [...backup_operation().slice(12)] : [];
          set_filter_operations(filter_operations_data);
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line
  }, [content_sidebar_selected,
    item_selected,
    loading_done.backup,
    loading_done.restore_management,
    loading_done.backup_schedule,
    set_loading_done])

  // useEffect(() => {
  //     set_backup_list((currentState: item_type[] | undefined) => {
  //         currentState?.map(item => { item.name = get_time(item?.start_time as string); return item })
  //         return currentState
  //     })
  // }, [backup_list])

  useEffect((): void => {
    sessionStorage.setItem("sidebar_selected", content_sidebar_selected);
    switch (content_sidebar_selected) {
      case "backup_configuration":
        backup_config_list && set_config_list_display(backup_config_list.length ?
          backup_config_list.filter(({name, backup_type}) => {
            return !table_list?.backup_type ? name : backup_type ===
              ((table_list?.backup_type === "Full" || table_list?.backup_type === "全量" || table_list?.backup_type === "完整") ? "Full" : table_list?.backup_type)
          }) : [])
        break;
      case "backup_management":
        backup_list && set_backup_list_display(backup_list.length ?
          backup_list.filter(({id, status}) => {
            return !table_list?.status ? id : status ? status === table_list?.status : table_list?.status === "Pending"
          }).sort((a: any, b: any) => {
            return Date.parse(b?.start_time) - Date.parse(a?.start_time)
          }) : [])
        break;
      case "restore_management":
        restore_list && set_restore_list_display(restore_list.length ?
          restore_list.filter(({id, status}) => {
            return !table_list?.status ? id : status === table_list?.status
          }).sort((a: any, b: any) => {
            return Date.parse(b?.restore_start_time) - Date.parse(a?.restore_start_time)
          }) : [])
        break;
      case "backup_schedule":
        backup_schedule_list && set_schedule_list_display(backup_schedule_list.length ?
          backup_schedule_list.filter(({name, status, frequency}) => {
            return !table_list?.status && !table_list?.frequency ? name :
              !table_list?.status && table_list?.frequency ? frequency === table_list?.frequency :
                table_list?.status && !table_list?.frequency ? status === table_list?.status :
                  status === table_list?.status && frequency === table_list?.frequency
          }) : [])
        break;
      default:
        break;
    }
  }, [backup_list, restore_list, backup_schedule_list, content_sidebar_selected, backup_config_list, table_list?.status, table_list?.backup_type, table_list?.frequency])

  // 自定义日期（编辑状态下初始值绑定）
  useEffect((): void => {
    if (item_selected?.frequency === "Monthly") {
      let muti_list: string[] | undefined = [];
      muti_list = item_selected?.cron_time?.replace(/,/g, "").split(" ").slice(0, item_selected?.cron_time.split(" ").length - 1);
      if (muti_list?.length) {
        set_month_selected_list(muti_list);
        set_month_item_status(monthOptions.current?.map(item => {
          return !!muti_list?.filter(mon => {
            return mon === item
          }).length
        }));
      }
    }
  }, [item_selected])

  return (
    <Row className="mt-20">
      <Col span={24} className={'pl-10'}>
        <Row className="pr-20">
          <div className={`${content_sidebar_toggle ? '' : 'side_fly_in'}`}>
            <Col sm={2} className="position-fixed left_second_menu">
              <Row className="header no_shadow">
                <Col sm={24} className="box_rounded inside_card_bg">
                  <Row>
                    <Col sm={24} className="text-center side_menu_img">
                      <img src={workspace_icon} alt=""/>
                    </Col>
                    <Tooltip title={instance_item_selected?.instanceName}>
                      <Col sm={24} className="text-center text-ellipsis-more line-clamp-2 instance-name">
                        {instance_item_selected?.instanceName}
                      </Col>
                    </Tooltip>
                  </Row>
                </Col>
                {!!sidemenu_list.current.length && sidemenu_list.current.map((item, index) =>
                  <Fragment key={`sidemenu_${index}`}>
                    <Col sm={24} className={`pointer ${index ? 'mt-8' : 'mt-20'}`}>
                      <div
                        className={`left_menu_button w-110 ${content_sidebar_selected === item ? "active" : ""} text-left cursor-pointer`}
                        onClick={() => {
                          set_loading_done((current_state: { [key: string]: 0 | 1 }) => ({
                            ...current_state,
                            backup_configuration: 0,
                            backup: 0,
                            restore_management: 0,
                            backup_schedule: 0
                          }));
                          set_content_sidebar_selected(item);
                          set_name("status", "", set_table_list);
                          set_name("backup_search", "", set_table_list);
                          set_search_value("");
                          set_selected_config(undefined);
                          item === "backup_schedule" && set_name("frequency", "", set_table_list);
                        }}
                      ><FormattedMessage id={item}/></div>
                    </Col>
                  </Fragment>
                )}
              </Row>
            </Col>
          </div>
          <Col sm={content_sidebar_toggle ? 22 : 24} offset={content_sidebar_toggle ? 2 : 0} className={`${content_sidebar_toggle ? "side_fly" : 'side_fly_false'}`}>
            <ArrowBack
              backTo={'instance_list'}
              sidebarToggle={true}
            />
            {loading && <Col className="loading-spin">
              <Spin/>
            </Col>}
            <Col span={24} className="backup_cell">
              <TableList
                operations={backup_operation}
                {...top_navbar.table_list_array}
                {...{
                  table_desc: [formatMessage({id: content_sidebar_selected}),
                    <Row className="pr-20">
                      <Col sm={14}
                           className="text-right">{`${formatMessage({id: 'instance_name'})}: ${instance_item_selected?.instanceName || "- -"}`}</Col>
                      <Col sm={5}
                           className="text-right">{`${formatMessage({id: 'service_name'})}: ${instance_item_selected?.service || "- -"}`}</Col>
                      <Col sm={5}
                           className="text-right">{`${formatMessage({id: 'plan_sp'})}: ${service_plan || "- -"}`}</Col>
                    </Row>],
                  titles: table_titles,
                  // items: backup_list_display,
                  // set_items: set_backup_list_display,
                  items: content_sidebar_selected === "backup_configuration" ? config_list_display :
                    content_sidebar_selected === "backup_management" ? backup_list_display :
                      content_sidebar_selected === "restore_management" ? restore_list_display : schedule_list_display,
                  set_items: content_sidebar_selected === "backup_configuration" ? set_config_list_display :
                    content_sidebar_selected === "backup_management" ? set_backup_list_display :
                      content_sidebar_selected === "restore_management" ? set_restore_list_display : set_backup_schedule_list,
                  path: "backup",
                  // selectable: 1,
                  custom_col: {
                    backup_type: (item: string) => formatMessage({id: item || "Full"}),
                    start_time: (item: number) => get_time(item),
                    end_time: (item: number) => {
                      return String(item).includes("0001") ? "--/--/---- --:--:--" : get_time(item)
                    },
                    expiry_time: (item: number) => {
                      return String(item).includes("0001") ? "--/--/---- --:--:--" : get_time(item)
                    },
                    restore_start_time: (item: number) => get_time(item),
                    restore_end_time: (item: number) => {
                      return String(item).includes("0001") ? "--/--/---- --:--:--" : get_time(item)
                    },
                    // 过长时打点显示
                    selected_database: (item: string) => item === "" ? formatMessage({id: "all_databases"}) :
                      <Row title={item}>{item}</Row>,
                    backup_destination_storage: (item: string) => <Row title={item}>{item}</Row>,
                    configuration_name: (item: string) => <Row title={item}>{item}</Row>,
                    schedule_name: (item: string) => <Row title={item}>{item}</Row>,
                    db_restore_id: (item: string) => <Col style={{whiteSpace: "normal"}}>
                      <Typography.Paragraph copyable={{text: item}}>{item}</Typography.Paragraph>
                    </Col>,
                    new_database_name: (item: string) => <Row title={item}>{item}</Row>,
                    backup_id: (item: string) => <Col style={{whiteSpace: "normal"}}>
                      <Typography.Paragraph copyable={{text: item}}>{item}</Typography.Paragraph>
                    </Col>,
                    // cron_time: (item: number) => get_time(item),
                    status: (status: string) => {
                      return <div>
                                            <span
                                              style={{color: backup_status[(status || (content_sidebar_selected !== "backup_schedule" ? "Pending" : "Disabled")).toLocaleLowerCase()]}}
                                              className="text-left pr-6 cursor-default">⬤</span>
                        <span
                          className="m-0 p-0 font-8">{status || (content_sidebar_selected !== "backup_schedule" ? "Pending" : "Disabled")}</span>
                      </div>
                    },
                    // Backup Management 与 Restore Management 详情页
                    // backup_name: (name: string, record: any) => {
                    //     return <span className="pointer backup-name-color"
                    //         onClick={() => {
                    //             set_item_selected(record);
                    //             set_action_id(content_sidebar_selected === "restore_management" ? 1 : 2);
                    //             set_visible(1);
                    //         }}>
                    //         {name}
                    //     </span>
                    // },
                    // Backup Configuration
                    backup: (_item: any, record: any) => {
                      return <Col className="d-flex"
                        onClick={async (): Promise<void> => {
                          set_loading?.(true);
                          const backup_list: any[] = (await http_get(`/backup/dbBackups?instanceId=${instance_item_selected?.instanceId}`, props) as any)?.data?.items || [];
                          const restore_list: any[] = (await http_get(`/backup/dbRestores?instanceId=${instance_item_selected?.instanceId}`, props) as any)?.data?.items || [];
                          const running_backup: any[] = backup_list.filter(({status}) => {
                            return status === "Running" || status === "Pending" || !status
                          });
                          const running_restore: any[] = restore_list.filter(({status}) => {
                            return status === "Running" || status === "Pending" || !status
                          });
                          set_loading?.(false);
                          if (!running_backup.length && !running_restore.length) {
                            set_action_id(1);
                            set_action(0);
                            set_visible(1);
                            set_item_selected(record);
                          } else {
                            Modal.warning({
                              style: {top: "200px"},
                              width: 430,
                              title: props.intl.formatMessage({id: "restore_warn_title"},
                                {type: `${props.intl.formatMessage({id: `${running_backup.length ? 'backup' : 'restore'}`})}`}),
                              content: props.intl.formatMessage({id: "restore_warn_content"})
                            })
                          }
                        }}
                      >
                        <PlayCircleOutlined className="row-icon"/>
                      </Col>
                    },
                    edit: (_item: any, record: any) => {
                      return <Col className="d-flex backup-icon">
                        <EditOutlined
                          className="row-icon"
                          onClick={() => {
                            content_sidebar_selected === "backup_configuration" && (async () => {
                              const new_data: any = await http_get(`/serviceHub/v2/serviceInstances/${instance_item_selected?.instanceId}/resources`, props);
                              set_db_list?.(new_data?.data);
                            })();
                            set_item_selected(record);
                            set_action_id(content_sidebar_selected === "backup_schedule" ? 1 : 2);
                            set_action(1);
                            set_visible(1);
                          }}/>
                      </Col>
                    },
                    delete: (_item: any, record: any) => {
                      return <DeleteOutlined
                        className="row-icon d-flex"
                        onClick={async (): Promise<void> => {
                          set_item_selected(record);
                          if (content_sidebar_selected !== "backup_schedule") {
                            set_loading(true);
                            const schedule_list: any[] | undefined = (await
                              http_get(`/backup/dbSchedules?instanceId=${record.manifest?.instance_id}&dbBackupConfigId=${record.db_backup_config?.id}`, props) as any)?.data?.items || [];
                            schedule_list && set_config_schedule_list(schedule_list);
                            set_loading(false);
                          } else {
                            if (record.status === "Enabled") {
                              set_loading(true);
                              const filter_backup_list: any[] | undefined = (await http_get(`/backup/dbBackups?instanceId=${instance_item_selected?.instanceId}`, props) as any)?.data?.items || [];
                              filter_backup_list && set_enable_schedule_list(filter_backup_list.filter((item: any) => {
                                // name 已去掉，此处判定条件有变 && item?.db_backup.name === record.schedule_name
                                return ((item?.status === "Running" || item?.status === "Pending"))
                              }));
                              set_loading(false);
                            } else {
                              set_enable_schedule_list([]);
                            }
                          }
                          set_action_id(content_sidebar_selected === "backup_schedule" ? 2 : 3);
                          set_action(2);
                          set_visible?.(1);
                        }}
                      />
                    },
                    // Backup Schedule
                    enable: (_item: any, record: any) => {
                      return <Switch
                        disabled={!record?.configuration_name}
                        checked={record.status === "Enabled"}
                        className="switch-icon"
                        onClick={() => {
                          set_action_id(record?.status === "Disabled" ? 3 : 4);
                          set_item_selected(record);
                          set_action(1);
                          set_visible(1);
                        }}/>
                    },
                  },
                  item_selected,
                  set_item_selected,
                  set_table_list,
                  // custom_col_style: {
                  //     status: { width: 150 }
                  // },
                  // has_batch_delete_button: content_sidebar_selected === "backup_management" || content_sidebar_selected === "restore_management" ? 1 : undefined,
                  has_backup_button: content_sidebar_selected === "backup_management" ? 1 : undefined,
                  no_create_button: content_sidebar_selected === "restore_management" ? 1 : undefined,
                  filter_operations,
                  visible,
                  set_visible,
                  action,
                  set_action,
                  action_id,
                  set_action_id,
                  // instance list 所选中项
                  instance_item_selected,
                  service_name,
                  disabled_hours,
                  set_disabled_hours,
                  content_sidebar_selected,
                  set_content_sidebar_selected,
                  // backup_destination,
                  // set_backup_destination,
                  selectable,
                  set_selectable,
                  selected_row_keys,
                  set_selected_row_keys,
                  // details 中 description 选项是否可编辑
                  // edit_description,
                  // set_edit_description,
                  // details 中 description 输入内容
                  // description,
                  // set_description,
                  // backup schedule 频率为 Monthly 时的多日期选择
                  month_selected_list,
                  set_month_selected_list,
                  month_item_status,
                  set_month_item_status,
                  monthOptions: monthOptions.current,
                  storage_list,
                  backup_config_list,
                  db_list,
                  set_db_list,
                  restore_db_list,
                  set_restore_db_list,
                  cron_text,
                  set_cron_text,
                  view_log,
                  set_view_log,
                  config_schedule_list,
                  enable_schedule_list,
                  set_loading_done,
                  hide_select_all: 1,
                  result_to_do,
                  no_sort_col: ["backup", "edit", "delete", "enable"],
                  selected_config,
                  set_selected_config,
                  start_time,
                  set_start_time,
                  instance_list,
                  set_instance_list,
                  loading_done,
                  set_loading,
                  default_sorter_col,
                  format_subscriptions,
                  datacenter_name,
                  user_info,
                  lang,
                  search_value,
                  set_search_value,
                  loading_key: content_sidebar_selected === "backup_configuration" ? "backup_configuration" :
                    content_sidebar_selected === "backup_schedule" ? "backup_schedule" :
                      content_sidebar_selected === "restore_management" ? "restore_management" : "backup",
                  // no_search: content_sidebar_selected === "backup_management" || content_sidebar_selected === "restore_management" ? 1 : undefined,
                  // date_pick: content_sidebar_selected === "backup_management" || content_sidebar_selected === "restore_management" ? 1 : undefined,
                  set_loading_done_items: () => {
                    set_loading_done((current_state: { [key: string]: 0 | 1 }) => ({
                      ...current_state,
                      backup_configuration: 0,
                      backup: 0,
                      restore_management: 0,
                      backup_schedule: 0
                    }));
                  },
                  please_input_name: content_sidebar_selected === "backup_configuration" ? "configuration_name" :
                    content_sidebar_selected === "backup_schedule" ? "schedule_name" :
                      content_sidebar_selected === "restore_management" ? "input_restore_id" : "input_backup_id",
                  dropdown_menus: content_sidebar_selected !== "backup_configuration" ?
                    content_sidebar_selected !== "backup_schedule" ? [
                      {
                        width: 8,
                        list: status_option_list,
                        caption: "status",
                        value: table_list?.status,
                        change_event: (event: string) => {
                          set_table_list((current_state: table_list_type) => ({
                            ...current_state,
                            status: event
                          }));
                          sessionStorage.setItem('backup_status', event);
                        },
                        has_all: status_option_list?.length > 1 ? 1 : undefined,
                      }
                    ] : [
                      {
                        list: status_option_list,
                        caption: "status",
                        value: table_list?.status,
                        change_event: (event: string) => {
                          set_table_list((current_state: table_list_type) => ({
                            ...current_state,
                            status: event
                          }));
                          sessionStorage.setItem('backup_status', event);
                        },
                        has_all: status_option_list?.length > 1 ? 1 : undefined,
                      },
                      {
                        list: type_option_list,
                        caption: content_sidebar_selected === "backup_schedule" ? "frequency" : "backup_type",
                        value: content_sidebar_selected === "backup_schedule" ? table_list?.frequency : table_list?.backup_type,
                        change_event: (event: string) => {
                          content_sidebar_selected === "backup_schedule" ?
                            set_table_list((current_state: table_list_type) => ({
                              ...current_state,
                              frequency: event
                            })) : set_table_list((current_state: table_list_type) => ({
                              ...current_state,
                              backup_type: event
                            }));
                          // set_name(content_sidebar_selected === "backup_schedule" ? "frequency" : "backup_type", event, set_table_list)
                        },
                        has_all: 1
                        // has_all: type_option_list?.length > 1 ? 1 : undefined,
                      }
                    ] :
                    [
                      {
                        width: 8,
                        list: type_option_list,
                        caption: "backup_type",
                        value: table_list?.backup_type,
                        change_event: (event: string) => {
                          set_table_list((current_state: table_list_type) => ({
                            ...current_state,
                            backup_type: event
                          }))
                        },
                        has_all: 1
                      }
                    ]
                }} />
            </Col>
          </Col>
        </Row>
      </Col>
    </Row>
  )

};

export default injectIntl(withRouter(BackUp) as any);
